'use client'

import { motion } from 'framer-motion'

const MenuToggleIcon = ({ setIsOpen, isOpen }) => {
  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const variants = {
    closed: (i) => ({
      rotateY: 0,
      translateY: 0,
      opacity: 1,
    }),
    open: (i) => ({
      rotateY: 180,
      translateY: i === 1 ? 8 : i === 3 ? -8 : 0,
      rotate: i === 1 ? 45 : i === 3 ? -45 : 0,
      opacity: i === 2 ? 0 : 1,
    }),
  }

  return (
    <button
      onClick={toggleMenu}
      className="flex lg:hidden w-8 h-8 sm:w-10 sm:h-10 flex-col items-center justify-center focus:outline-none pl-0 ml-0"
      aria-label={isOpen ? "Close menu" : "Open menu"}
    >
      {[1, 2, 3].map((i) => (
        <motion.div
          key={i}
          className="w-6 h-[2px] bg-current my-[3px] rounded-full"
          variants={variants}
          animate={isOpen ? "open" : "closed"}
          initial="closed"
          custom={i}
          transition={{
            type: 'spring',
            stiffness: 100,
            damping: 10,
          }}
        />
      ))}
    </button>
  )
}

export default MenuToggleIcon

